import request from 'src/api'
import { controlColumn, orderFirstDataColumn, responsiveControlColumn } from 'src/datatableControl'
import deleteRecord from 'src/deleteRecord'
import { addToast } from 'src/toasts'
import { lockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { contractPeopleFunctions } from 'packs/contract_people/functions'
import initDatatableChrome from 'src/datatableChrome'
import onIndexRefresh from 'src/indexRefresh'

export default () => {
  contractPeopleFunctions()

	// datatable init
  let contractPeopleDatatable = $('#contract-people-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('contractPeopleIndexPageLength') || 25),
    "processing": true,
    "order": orderFirstDataColumn(),
    // TODO.md U-76 / F-123: the control column lives in src/datatableControl.js — the reasoning, the
    // library line numbers and the lost-ORDER-BY measurement are all there, once.
    "responsive": responsiveControlColumn(),
    "serverSide": true,
    "ajax": {
      "url": $('#contract-people-datatable').data('source')
    },
    "columns": [
      controlColumn(),
      { "data": "first_name" },
      { "data": "last_name" },
      { "data": "phone" },
      { "data": "customers" }
    ],
    initComplete(settings, json) {
      initDatatableChrome('contract-people-datatable')
  	}
  })

  // T-102 / T-108 / U-48: reload this page's table when a save says so. The `off()`/`on()` pair and
  // `resetPaging: false` live in `src/indexRefresh` — five packs carried a copy of both.
  onIndexRefresh('contractPeopleIndex', contractPeopleDatatable)

  $('#content').on('change', "[name='contract-people-datatable_length']", function() {
    localStorage.setItem('contractPeopleIndexPageLength', $(this).val())
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    contractPeopleDatatable.search('').draw()
  })

  $('#content').on('click', '#add_contract_person', function() {
    lockButton('#add_contract_person')
    offcanvasRight.show()
    $.getScript('/contract_people/new')
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    $(this).blur()
    if ($("#basic-information").find('form').attr('action').includes('contract_people')) {
      lockButton('#confirmDelete')

      // T-111: `deleteRecord` clears `dirty` before this runs, which is what makes the close below safe —
      // `hide.bs.offcanvas` reads the flag and `hidden.bs.offcanvas` clears it only afterwards (F-148).
      deleteRecord($("#offcanvasRight .tab-pane.active form").attr('action'))
        .then(res => {
          addToast(res.body.success, 'notice')
          if (contractPeopleDatatable !== null) {
            contractPeopleDatatable.ajax.reload()
          }
          mainModal.hide()
          $('#offcanvasRight .btn-close').click()
        })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })
}
